import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=88db73e0&"
import script from "./GameContent.vue?vue&type=script&lang=js&"
export * from "./GameContent.vue?vue&type=script&lang=js&"
import style0 from "./GameContent.vue?vue&type=style&index=0&id=88db73e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports